// Get version number based on year and git commit count
export const getVersion = () => {
  const year = new Date().getFullYear();
  const commitCount = process.env.REACT_APP_COMMIT_COUNT || '0';
  return `${year}.${commitCount}`;
};
